import React, { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faHouse } from '@fortawesome/free-solid-svg-icons';
import MostrarCarrito from './MostrarCarrito';
const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

function ProductosSinCodigo() {
  const [carrito, setCarrito] = useState([]);
  const [total, setTotal] = useState(0);
  const [cantidades, setCantidades] = useState({});
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
  const [busqueda, setBusqueda] = useState('');
  const [ultimoProductoAgregado, setUltimoProductoAgregado] = useState(null);
  const { loading, error, data } = useQuery(GET_PRODUCTOS);

  const numColumnas = 5;

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(carrito));
    recalcularTotal();
  }, [carrito]);

  const productosFiltrados = data?.getProductos.filter((producto) =>
    producto.nombre.toLowerCase().includes(busqueda.toLowerCase())
  );

  useEffect(() => {
    const manejarTeclas = (event) => {
      if (event.key === 'ArrowUp') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex - numColumnas >= 0 ? prevIndex - numColumnas : prevIndex
        );
      } else if (event.key === 'ArrowDown') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex + numColumnas < productosFiltrados.length ? prevIndex + numColumnas : prevIndex
        );
      } else if (event.key === 'ArrowLeft') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : prevIndex
        );
      } else if (event.key === 'ArrowRight') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex < productosFiltrados.length - 1 ? prevIndex + 1 : prevIndex
        );
      } else if (event.key === 'Enter') {
        agregarAlCarrito(productosFiltrados[indiceSeleccionado]);
      }
    };

    window.addEventListener('keydown', manejarTeclas);
    return () => {
      window.removeEventListener('keydown', manejarTeclas);
    };
  }, [indiceSeleccionado, productosFiltrados]);

  const agregarAlCarrito = (producto) => {
    const cantidad = cantidades[producto._id] || 1;
    const productoEnCarrito = carrito.find((item) => item._id === producto._id);

    if (productoEnCarrito) {
      setCarrito((prevCarrito) =>
        prevCarrito.map((item) =>
          item._id === producto._id ? { ...item, cantidad: item.cantidad + cantidad } : item
        )
      );
    } else {
      setCarrito((prevCarrito) => [...prevCarrito, { ...producto, cantidad }]);
    }

    setUltimoProductoAgregado({ ...producto, cantidad });
  };

  const cambiarCantidadProducto = (productId, nuevaCantidad) => {
    setCantidades((prevCantidades) => ({
      ...prevCantidades,
      [productId]: nuevaCantidad,
    }));
  };

  const recalcularTotal = () => {
    const nuevoTotal = carrito.reduce((acc, producto) => {
      const subtotal = producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };

  if (loading) return <p>Cargando productos...</p>;
  if (error) return <p>Error al cargar los productos.</p>;

  return (
    <div>
      <a className="btn-carrito btn" href="ver-carrito">
        <FontAwesomeIcon icon={faShoppingCart} />
      </a>

      <a className="btn-medicina btn" href="/">
        <FontAwesomeIcon icon={faHouse} />
      </a>

      <input
      className='busqueda'
        type="text"
        placeholder="Buscar productos"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        style={{ margin: '20px 0', padding: '10px', width: '100%' }}
      />

    

      <div className="container">
        <div className="row">
          {productosFiltrados.map((producto, index) => (
            <div
              className={`card-legumbre col-2 ${indiceSeleccionado === index ? 'seleccionado' : ''}`}
              key={producto._id}
            >
              <div className="card-body">
                <h6 className="card-title">{producto.nombre}</h6>
                <p className="card-text">
                  <img src={producto.imagen} width="35px" alt={producto.nombre} />
                  <h4>{producto.precio}</h4>
                </p>
                <p>
                  <input
                    type="number"
                    min="1"
                    value={cantidades[producto._id] || 1}
                    onChange={(e) => cambiarCantidadProducto(producto._id, parseInt(e.target.value))}
                    style={{ width: '60px', marginRight: '10px' }}
                  />
                  <button
                    className="btn btn-primary btn-legumbre"
                    onClick={() => agregarAlCarrito(producto)}
                  >
                    Agregar
                  </button>
                </p>
              </div>
            </div>
          ))}
        
        </div>
      </div>
    </div>
  );
}

export default ProductosSinCodigo;
